import { render, staticRenderFns } from "./cities.mpx?vue&type=template&id=5fb012de&scoped=true&page=true"
import script from "./cities.mpx?vue&type=script&lang=js&page=true"
export * from "./cities.mpx?vue&type=script&lang=js&page=true"
import style0 from "./cities.mpx?vue&type=style&index=0&id=5fb012de&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m4d9fb10e%22%7D&page=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb012de",
  null
  
)

export default component.exports